import './FollowingFilter.scss';

import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Select } from 'antd';
import { UpdateQueryParams } from '@hooks';

import React, { useCallback } from 'react';

const options: Array<{ label: string; value: boolean; }> = [
	{
		label: COPY_SPECIFIC.FOLLOWING,
		value: true
	},
	{
		label: `${COPY_SPECIFIC.NOT} ${COPY_SPECIFIC.FOLLOWING}`,
		value: false
	}
];

export type FollowingFilterParams = { isFollowing?: boolean };

export interface FollowingFilterProps {
	disabled?: boolean;
	onChange: UpdateQueryParams<FollowingFilterParams>;
	value?: boolean;
}

export const FollowingFilter: React.FC<FollowingFilterProps> = ({ disabled, onChange, value }) => {
	const handleOnChange = useCallback((isFollowing: boolean) => {
		onChange({ isFollowing });
	}, [ onChange ]);

	return (
		<Select
			allowClear
			className='following-filter'
			disabled={ disabled }
			onChange={ handleOnChange }
			options={ options }
			placeholder={ COPY_SPECIFIC.FOLLOWING }
			value={ value } />
	);
};
